"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.getDisplayContentType = exports.default = exports.cssAnchorName = exports.config = exports.CONVERSATION_LIKE_TYPES = exports.CHARACTER_LIMIT = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _axios = _interopRequireDefault(require("axios"));

var _classnames = _interopRequireDefault(require("classnames"));

var _zod = require("zod");

var _TopicVoteCount = require("@insided/destination/uikit/TopicVoteCount");

var _TopicReplyCount = require("@insided/destination/uikit/TopicReplyCount");

var _TopicViewsCount = require("@insided/destination/uikit/TopicViewsCount");

var _EventListOverview = require("@insided/deprecated-preact-components/Event/EventListOverview");

var _widgetContainer = _interopRequireWildcard(require("@insided/deprecated-preact-components/widget-container"));

var _CardWidgetText = require("./CardWidgetText");

var _FeaturedCard = _interopRequireDefault(require("./FeaturedCard"));

var _FeaturedCardContainer = _interopRequireWildcard(require("./FeaturedCardContainer"));

var _FeaturedProductAreas = _interopRequireDefault(require("./FeaturedProductAreas"));

var _Content = require("@insided/destination/modules/Content");

var _PostMetaContainer = require("./PostMetaContainer");

var _ShowMoreButton = _interopRequireDefault(require("./ShowMoreButton"));

var _types = require("./types");

var _constants = require("@insided/destination/shared/constants");

var _FeaturedList = _interopRequireDefault(require("./FeaturedList"));

var _common = require("@insided/shared/utils/common");

var _contentType = require("@insided/shared/utils/contentType");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CONVERSATION_LIKE_TYPES = [_contentType.CONTENT_TYPE_CONVERSATION, _contentType.CONTENT_TYPE_DISCUSSION];
exports.CONVERSATION_LIKE_TYPES = CONVERSATION_LIKE_TYPES;
var CHARACTER_LIMIT = 150;
exports.CHARACTER_LIMIT = CHARACTER_LIMIT;

var getDisplayContentType = function getDisplayContentType(topic) {
  var actualContentType = topic.contentType; // Only transform non-legacy (unified) conversation/discussion topics to ideas

  if (_common.common.isModuleActive('bugContentType') && CONVERSATION_LIKE_TYPES.includes(actualContentType) && !('post' in topic)) {
    return _contentType.CONTENT_TYPE_IDEA;
  }

  return actualContentType;
};

exports.getDisplayContentType = getDisplayContentType;
var widgetName = 'featured_topics';
exports.widgetName = widgetName;
var cssAnchorName = "widget-featured_topics";
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  topics: _zod.z.array(_zod.z.object({
    id: _zod.z.number(),
    type: _zod.z.string()
  })),
  selectedMobileLayout: _zod.z.union([_zod.z.literal('verticallyStacked'), _zod.z.literal('horizontallyScrollable')], undefined).optional(),
  selectedCardsPerRow: _zod.z.union([_zod.z.literal(2), _zod.z.literal(3), _zod.z.literal(4), _zod.z.literal(5), _zod.z.literal(6)]).optional(),
  buttonURL: _zod.z.string(),
  buttonLabel: _zod.z.string(),
  firstTopicsNumber: _zod.z.number(),
  selectedDisplayViewPreference: _zod.z.string()
}).merge(_widgetContainer.widgetContainerConfig);

exports.config = config;

var FeaturedTopicsWidget = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FeaturedTopicsWidget, _Component);

  var _super = _createSuper(FeaturedTopicsWidget);

  function FeaturedTopicsWidget(props) {
    var _props$featuredTopics;

    var _this;

    (0, _classCallCheck2.default)(this, FeaturedTopicsWidget);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasWidgetTitle", Boolean(_this.props.config.title));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasWidgetSubtitle", Boolean(_this.props.config.subtitle));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "addVoteHandler", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(index, hasCurrentUserVoted) {
        var event, newFeaturedTopics, topic, actualContentType, isConversationType, conversationTopic, ideaTopic, voteCount, apiContentType, action, userKey, topicId;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof window === 'undefined')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if ((0, _insidedDataStorage.getInsidedData)('user').userid) {
                  _context.next = 5;
                  break;
                }

                event = new window.CustomEvent('GuestUserAction');
                return _context.abrupt("return", window.dispatchEvent(event));

              case 5:
                newFeaturedTopics = (0, _toConsumableArray2.default)(_this.state.featuredTopics);
                topic = newFeaturedTopics[index];
                actualContentType = topic.contentType;
                isConversationType = CONVERSATION_LIKE_TYPES.includes(actualContentType); // Update the count - use likes for conversation types, votes for ideas

                if (isConversationType) {
                  conversationTopic = topic;
                  conversationTopic.likes = hasCurrentUserVoted ? --conversationTopic.likes : ++conversationTopic.likes;
                  conversationTopic.hasCurrentUserLiked = !hasCurrentUserVoted;
                } else {
                  ideaTopic = topic;
                  voteCount = ideaTopic.voteCount;
                  ideaTopic.voteCount = hasCurrentUserVoted ? --voteCount : ++voteCount;
                  ideaTopic.hasCurrentUserVoted = !hasCurrentUserVoted;
                }

                _this.setState({
                  featuredTopics: newFeaturedTopics
                }); // Use actual contentType for API call


                apiContentType = isConversationType ? 'conversations' : 'ideas';
                action = hasCurrentUserVoted ? isConversationType ? 'unlike' : 'unvote' : isConversationType ? 'like' : 'vote';
                userKey = isConversationType ? hasCurrentUserVoted ? 'unlikedBy' : 'likedBy' : hasCurrentUserVoted ? 'unvotedBy' : 'votedBy';
                topicId = topic.privateId;
                _context.next = 17;
                return _axios.default.post("/community/api/".concat(apiContentType, "/").concat(topicId, "/").concat(action), (0, _defineProperty2.default)({}, userKey, (0, _insidedDataStorage.getInsidedData)('user').userid));

              case 17:
                return _context.abrupt("return", _context.sent);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    _this.state = {
      featuredTopics: (_props$featuredTopics = props.featuredTopics) !== null && _props$featuredTopics !== void 0 ? _props$featuredTopics : []
    };
    _this.addLikeHandler = _this.addLikeHandler.bind((0, _assertThisInitialized2.default)(_this));
    _this.addVoteHandler = _this.addVoteHandler.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(FeaturedTopicsWidget, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this$props$featuredT;

        var isEventTypeTopics, res;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                isEventTypeTopics = (_this$props$featuredT = this.props.featuredTopics) === null || _this$props$featuredT === void 0 ? void 0 : _this$props$featuredT.some(function (topic) {
                  return topic.contentType === 'event';
                });

                if (isEventTypeTopics) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                _context2.prev = 3;
                _context2.next = 6;
                return _axios.default.get('/event/eventTimeSettings', {
                  headers: {
                    Accept: 'application/json'
                  }
                });

              case 6:
                res = _context2.sent;
                this.setState({
                  timeConfig: res.data
                });
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](3);
                throw _context2.t0;

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 10]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "totalTopics",
    get: function get() {
      var _this$props$featuredT2, _this$props$featuredT3;

      return (_this$props$featuredT2 = (_this$props$featuredT3 = this.props.featuredTopics) === null || _this$props$featuredT3 === void 0 ? void 0 : _this$props$featuredT3.length) !== null && _this$props$featuredT2 !== void 0 ? _this$props$featuredT2 : 0;
    }
  }, {
    key: "topicsFullWidth",
    get: function get() {
      var _this$props$config$fi;

      return (_this$props$config$fi = this.props.config.firstTopicsNumber) !== null && _this$props$config$fi !== void 0 ? _this$props$config$fi : 0;
    }
  }, {
    key: "addLikeHandler",
    value: function () {
      var _addLikeHandler = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(index) {
        var _getInsidedData, userId, event, newFeaturedTopics, topic, currentUserLiked, action, post, id, likes, liked, topicHasCurrentUserLiked, url, newData;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(typeof window === 'undefined')) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                _getInsidedData = (0, _insidedDataStorage.getInsidedData)('user'), userId = _getInsidedData.userid;

                if (userId) {
                  _context3.next = 6;
                  break;
                }

                event = new window.CustomEvent('GuestUserAction');
                return _context3.abrupt("return", window.dispatchEvent(event));

              case 6:
                newFeaturedTopics = (0, _toConsumableArray2.default)(this.state.featuredTopics);
                topic = newFeaturedTopics[index];

                if (!(0, _types.isEvent)(topic)) {
                  _context3.next = 10;
                  break;
                }

                return _context3.abrupt("return");

              case 10:
                if (!(0, _types.isUnified)(topic)) {
                  _context3.next = 18;
                  break;
                }

                currentUserLiked = topic.likeSet.some(function (id) {
                  return id === parseInt(userId);
                });
                action = currentUserLiked ? 'unlike' : 'like';
                _context3.next = 15;
                return _axios.default.post("/community/api/".concat(topic.contentType, "s/").concat(action));

              case 15:
                if (currentUserLiked) {
                  topic.likeSet = topic.likeSet.filter(function (id) {
                    return id !== parseInt(userId);
                  });
                } else {
                  topic.likeSet.push(parseInt(userId));
                }

                this.setState({
                  featuredTopics: newFeaturedTopics
                });
                return _context3.abrupt("return");

              case 18:
                post = topic.post, id = topic.id, likes = topic.likes, liked = topic.hasCurrentUserLiked;
                topic.likes = liked ? --likes : ++likes;
                topic.hasCurrentUserLiked = !liked;
                this.setState({
                  featuredTopics: newFeaturedTopics
                });
                topicHasCurrentUserLiked = String(topic.hasCurrentUserLiked);
                url = "/member/like?like=".concat(topicHasCurrentUserLiked, "&tid=").concat(id);
                newData = {
                  liked: topic.hasCurrentUserLiked,
                  postid: post === null || post === void 0 ? void 0 : post.id
                };
                _context3.next = 27;
                return _axios.default.post(url, _objectSpread({}, newData));

              case 27:
                return _context3.abrupt("return", _context3.sent);

              case 28:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function addLikeHandler(_x3) {
        return _addLikeHandler.apply(this, arguments);
      }

      return addLikeHandler;
    }()
  }, {
    key: "renderButton",
    value: function renderButton(featuredTopic, index) {
      var _this2 = this;

      if (typeof window === 'undefined') return null;
      var displayContentType = getDisplayContentType(featuredTopic);
      var actualContentType = featuredTopic.contentType;

      if (displayContentType === 'event') {
        return null;
      }

      if (displayContentType === 'idea') {
        var _ref5;

        var user = (0, _insidedDataStorage.getInsidedData)('user'); // If actual contentType is not idea (conversation/discussion), use likes instead of votes

        if (actualContentType !== _contentType.CONTENT_TYPE_IDEA) {
          var _ref2 = featuredTopic,
              hasCurrentUserLiked = _ref2.hasCurrentUserLiked,
              likes = _ref2.likes;

          var _hasVoted = hasCurrentUserLiked !== null && hasCurrentUserLiked !== void 0 ? hasCurrentUserLiked : false;

          return (0, _preact.h)(_TopicVoteCount.FeaturedTopicVoteButton, {
            hasVoted: _hasVoted,
            votes: likes !== null && likes !== void 0 ? likes : 0,
            onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
              return _regenerator.default.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return _this2.addVoteHandler(index, _hasVoted);

                    case 2:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4);
            }))
          });
        }

        var _ref4 = featuredTopic,
            hasCurrentUserVoted = _ref4.hasCurrentUserVoted,
            voteCount = _ref4.voteCount,
            votes = _ref4.votes;
        var hasVoted = hasCurrentUserVoted !== null && hasCurrentUserVoted !== void 0 ? hasCurrentUserVoted : user && votes.includes(user.userid);
        return (0, _preact.h)(_TopicVoteCount.FeaturedTopicVoteButton, {
          hasVoted: hasVoted,
          votes: (_ref5 = voteCount !== null && voteCount !== void 0 ? voteCount : votes.length) !== null && _ref5 !== void 0 ? _ref5 : 0,
          onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
            return _regenerator.default.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return _this2.addVoteHandler(index, hasVoted);

                  case 2:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          }))
        });
      }

      return null;
    }
  }, {
    key: "renderItem",
    value: function renderItem(featuredTopic, index) {
      var displayContentType = getDisplayContentType(featuredTopic); // Check actual contentType for events (can't be transformed)

      if (featuredTopic.contentType === 'event') {
        return this.renderEvent(featuredTopic, index);
      } // Use displayContentType for visual rendering decisions


      if (displayContentType === 'idea') {
        return this.renderIdea(featuredTopic, index);
      }

      if (featuredTopic.contentType === 'productUpdate') {
        return this.renderProductUpdate(featuredTopic, index);
      }

      if ('post' in featuredTopic) {
        return this.renderLegacyTopic(featuredTopic, index);
      }

      return this.renderTopicFromUnified(featuredTopic, index);
    }
  }, {
    key: "renderEvent",
    value: function renderEvent(featuredEvent, index) {
      var title = featuredEvent.title,
          url = featuredEvent.url,
          startsAt = featuredEvent.startsAt,
          endsAt = featuredEvent.endsAt,
          image = featuredEvent.image,
          type = featuredEvent.type,
          location = featuredEvent.location,
          attendeeCount = featuredEvent.attendeeCount,
          attendees = featuredEvent.attendees,
          isLoggedInUserAttendee = featuredEvent.isLoggedInUserAttendee,
          timezoneName = featuredEvent.timezoneName;
      var timeConfig = this.state.timeConfig;
      var fullWidth = (0, _FeaturedCardContainer.isFullWidth)({
        index: index,
        topicsFullWidth: this.topicsFullWidth,
        totalTopics: this.totalTopics
      });
      return (0, _preact.h)(_EventListOverview.EventListItemView, {
        title: title,
        startAt: startsAt,
        endAt: endsAt,
        destinationUrl: url,
        image: image,
        type: type,
        hasWidgetTitle: this.hasWidgetTitle,
        hasWidgetSubtitle: this.hasWidgetSubtitle,
        location: location,
        isFullWidth: fullWidth,
        isFeatured: true,
        attendees: attendees,
        attendeeCount: attendeeCount,
        isLoggedInUserAttendee: isLoggedInUserAttendee,
        timeConfig: timeConfig,
        timezoneName: timezoneName
      });
    }
  }, {
    key: "renderProductUpdate",
    value: function renderProductUpdate(topic, index) {
      var content = topic.content,
          label = topic.label,
          title = topic.title,
          url = topic.url,
          featuredImage = topic.featuredImage,
          replyCount = topic.replyCount,
          views = topic.views,
          author = topic.author,
          publishedAt = topic.publishedAt,
          productAreas = topic.productAreas;
      return (0, _preact.h)(_FeaturedCard.default, {
        featuredImage: featuredImage,
        featuredImageAlt: "Featured Product Update image ".concat(index + 1),
        title: title,
        hasWidgetSubtitle: this.hasWidgetSubtitle,
        hasWidgetTitle: this.hasWidgetTitle,
        url: url,
        label: label
      }, this.renderContent(content, featuredImage, index), this.renderAreas(productAreas, index), (0, _preact.h)(_PostMetaContainer.PostMetaContainer, {
        author: author,
        timestamp: publishedAt
      }, (0, _preact.h)(_TopicViewsCount.TopicViewsCount, {
        views: views
      }), (0, _preact.h)(_TopicReplyCount.TopicReplyCount, {
        replyCount: replyCount
      })));
    } // TODO: SUC-193 Old ideation module is not supported when middleware module is enabled since unified show it's type as discussion

  }, {
    key: "renderTopicFromUnified",
    value: function renderTopicFromUnified(featuredTopic, index) {
      var title = featuredTopic.title,
          featuredImage = featuredTopic.featuredImage,
          label = featuredTopic.label,
          createdAt = featuredTopic.createdAt,
          replyCount = featuredTopic.replyCount,
          views = featuredTopic.views,
          url = featuredTopic.url,
          content = featuredTopic.content,
          author = featuredTopic.author;
      return (0, _preact.h)(_FeaturedCard.default, {
        featuredImage: featuredImage,
        featuredImageAlt: "Featured Topic image ".concat(index + 1),
        title: title,
        url: url,
        hasWidgetTitle: this.hasWidgetTitle,
        hasWidgetSubtitle: this.hasWidgetSubtitle,
        label: label
      }, this.renderContent(content, featuredImage, index), (0, _preact.h)(_PostMetaContainer.PostMetaContainer, {
        author: author,
        timestamp: createdAt
      }, (0, _preact.h)(_TopicViewsCount.TopicViewsCount, {
        views: views
      }), (0, _preact.h)(_TopicReplyCount.TopicReplyCount, {
        replyCount: replyCount
      })));
    }
  }, {
    key: "renderLegacyTopic",
    value: function renderLegacyTopic(featuredTopic, index) {
      var title = featuredTopic.title,
          featuredImage = featuredTopic.featuredImage,
          label = featuredTopic.label,
          replyCount = featuredTopic.replyCount,
          views = featuredTopic.views,
          url = featuredTopic.url,
          post = featuredTopic.post;
      return (0, _preact.h)(_FeaturedCard.default, {
        featuredImage: featuredImage,
        featuredImageAlt: "Featured Idea image ".concat(index + 1),
        title: title,
        hasWidgetTitle: this.hasWidgetTitle,
        hasWidgetSubtitle: this.hasWidgetSubtitle,
        url: url,
        label: label
      }, this.renderContent(post.content, featuredImage, index), (0, _preact.h)(_PostMetaContainer.PostMetaContainer, {
        author: post.author,
        timestamp: post.creationDate
      }, (0, _preact.h)(_TopicViewsCount.TopicViewsCount, {
        views: views
      }), (0, _preact.h)(_TopicReplyCount.TopicReplyCount, {
        replyCount: replyCount
      })));
    } // TODO: SUC-193 Using internal api with publicId endpoint returns different result than calling with specific topic type and private id so this function wont work until specific idea enpoint is used

  }, {
    key: "renderIdea",
    value: function renderIdea(topic, index) {
      var content = topic.content,
          label = topic.label,
          title = topic.title,
          featuredImage = topic.featuredImage,
          url = topic.url,
          author = topic.author,
          createdAt = topic.createdAt,
          ideationStatus = topic.ideationStatus,
          productAreas = topic.productAreas,
          contentType = topic.contentType,
          bugStatus = topic.bugStatus;
      var titleSlotContent = ideationStatus ? (0, _preact.h)(_Content.IdeationStatusView, {
        ideationStatus: ideationStatus
      }) : bugStatus ? (0, _preact.h)(_Content.BugStatusView, {
        bugStatus: bugStatus
      }) : null;
      return (0, _preact.h)(_FeaturedCard.default, {
        title: title,
        url: url,
        hasWidgetTitle: this.hasWidgetTitle,
        hasWidgetSubtitle: this.hasWidgetSubtitle,
        featuredImage: featuredImage,
        featuredImageAlt: "Featured Idea image ".concat(index + 1),
        label: label,
        showLabel: false,
        titleSlot: titleSlotContent
      }, this.renderContent(content, featuredImage, index), contentType === _contentType.CONTENT_TYPE_IDEA && this.renderAreas(productAreas, index), (0, _preact.h)(_PostMetaContainer.PostMetaContainer, {
        author: author,
        timestamp: createdAt
      }, this.renderButton(topic, index)));
    }
  }, {
    key: "renderContent",
    value: function renderContent(content, featuredImage, index) {
      var fullWidth = (0, _FeaturedCardContainer.isFullWidth)({
        index: index,
        topicsFullWidth: this.topicsFullWidth,
        totalTopics: this.totalTopics
      }); // SSR: Default to showing content (assume desktop), client will hide on mobile if needed

      var isNotMobile = typeof window !== 'undefined' ? (0, _insidedDataStorage.getInsidedData)('device') : true;

      if (isNotMobile && fullWidth || !featuredImage) {
        return (0, _preact.h)(_CardWidgetText.CardWidgetText, {
          content: content,
          characterLimit: CHARACTER_LIMIT
        });
      }

      return null;
    }
  }, {
    key: "renderAreas",
    value: function renderAreas(assignedProductAreas, index) {
      var _this$props$allProduc = this.props.allProductAreas,
          allProductAreas = _this$props$allProduc === void 0 ? [] : _this$props$allProduc;
      var fullWidth = (0, _FeaturedCardContainer.isFullWidth)({
        index: index,
        topicsFullWidth: this.topicsFullWidth,
        totalTopics: this.totalTopics
      });

      if (assignedProductAreas.length === 0) {
        return null;
      }

      return (0, _preact.h)(_FeaturedProductAreas.default, {
        fullWidth: fullWidth,
        allProductAreas: allProductAreas,
        assignedProductAreas: assignedProductAreas
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _config$selectedMobil,
          _config$selectedDispl,
          _this3 = this;

      var _this$props = this.props,
          config = _this$props.config,
          _this$props$widgetNam = _this$props.widgetName,
          widgetName = _this$props$widgetNam === void 0 ? 'featured-topics' : _this$props$widgetNam,
          isNested = _this$props.isNested,
          isSidebar = _this$props.isSidebar;
      var selectedMobileLayout = (_config$selectedMobil = config.selectedMobileLayout) !== null && _config$selectedMobil !== void 0 ? _config$selectedMobil : 'horizontallyScrollable';
      var buttonLabel = config.buttonLabel,
          buttonURL = config.buttonURL;
      var featuredTopics = this.state.featuredTopics;
      var hasButton = buttonLabel && buttonURL;
      var isListView = _constants.DisplayViewOptions.List === (config === null || config === void 0 ? void 0 : (_config$selectedDispl = config.selectedDisplayViewPreference) === null || _config$selectedDispl === void 0 ? void 0 : _config$selectedDispl.toLowerCase());

      if (!featuredTopics.length) {
        return null;
      }

      return (0, _preact.h)(_widgetContainer.default, {
        config: config,
        widgetName: widgetName
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)(_constants.MOBILE_VIEW_LAYOUTS_SNAKE_CASE[selectedMobileLayout], {
          'featured-topics__list--no-slider': featuredTopics.length === 1,
          'featured-topics__list': !isListView
        }),
        "data-bounded-context": "Navigation",
        "data-entity": widgetName
      }, isListView ? (0, _preact.h)(_FeaturedList.default, {
        featuredTopics: featuredTopics,
        voteHandler: this.addVoteHandler,
        showMoreUrl: buttonURL,
        showMoreText: buttonLabel
      }) : featuredTopics.map(function (featuredTopic, index) {
        return (0, _preact.h)(_FeaturedCardContainer.default, {
          key: index,
          topicsFullWidth: _this3.topicsFullWidth,
          totalTopics: featuredTopics.length,
          index: index,
          contentType: featuredTopic.contentType,
          featuredImage: (0, _types.isEvent)(featuredTopic) ? featuredTopic.image : featuredTopic.featuredImage,
          selectedCardsPerRow: config.selectedCardsPerRow,
          isNested: isNested,
          isSidebar: isSidebar
        }, (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)(featuredTopic.url),
          className: "featured-topic__url-link",
          "data-track-type": "click",
          "data-element-name": "Topic link",
          title: featuredTopic.title,
          "aria-label": featuredTopic.title
        }), _this3.renderItem(featuredTopic, index));
      })), !isListView && hasButton && (0, _preact.h)(_ShowMoreButton.default, {
        label: buttonLabel,
        href: (0, _absoluteUrlRuntime.resolveUrl)(buttonURL)
      }));
    }
  }]);
  return FeaturedTopicsWidget;
}(_preact.Component);

exports.default = FeaturedTopicsWidget;